import { useMemo } from "react";
import { useLayerListModule } from "./useAppModule";

export const useFilterDevMode = () => {
  const layerListModule = useLayerListModule();

  return useMemo(() => {
    const { options } = layerListModule || {};

    return !!(options && options.allowDevView);
  }, [layerListModule]);
};
